import { env } from '@/env';
import { useHasLogtoRole } from '@/hooks/useHasLogtoRole';

function useSfidaAccesa(): boolean {
  return useHasLogtoRole('beta');
}

const sfidaSpenta = (): boolean => false;

/**
 * Vero quando il bottone «Sfida» di un amico apre il pannello della sfida di piattaforma
 * (`SfidaSheet`) invece di quello di QDuels (`ChallengeOptionsSheet`).
 *
 * E' la stessa serratura della sezione tornei su Limulo: il flag `featureLimuloEnabled` (acceso
 * solo su staging) **e** il ruolo `beta` (in `routes/router.tsx` le rotte `/limulo/*` stanno
 * dietro `<RoleGate role="beta">`). Il pannello legge `/v1/games` dal BFF Limulo, quindi vuole
 * le stesse chiavi. A flag spento, e quindi in produzione, resta QDuels com'e'.
 *
 * ⚠️ **L'hook si sceglie al caricamento del modulo, non a ogni chiamata.** Lo chiama OGNI riga della
 * lista amici, e `useHasLogtoRole` iscrive ciascuna allo store dei ruoli con tre ascoltatori su
 * `window`: a flag spento, cioe' in produzione, sarebbero N iscrizioni e N² risvegli per rispondere
 * sempre `false`. Il flag e' letterale e piegato a compile-time, quindi a flag spento resta la
 * funzione costante e il ruolo non si legge affatto. Garanzia: `tests/sfida-serratura.test.ts`.
 */
export const useSfidaDiPiattaforma: () => boolean = env.featureLimuloEnabled ? useSfidaAccesa : sfidaSpenta;
